export const SET_LAST_SEARCH_CRITERIA = "SET_LAST_SEARCH_CRITERIA";
export const SET_LAST_SEARCH_CRITERIA_ERROR = "SET_LAST_SEARCH_CRITERIA_ERROR";
export const CLEAR_LAST_SEARCH_CRITERIA = "CLEAR_LAST_SEARCH_CRITERIA";